import { render, staticRenderFns } from "./PhotoPage.vue?vue&type=template&id=01489ae5&scoped=true&"
import script from "./PhotoPage.vue?vue&type=script&lang=js&"
export * from "./PhotoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01489ae5",
  null
  
)

export default component.exports